import authImg from "../../public/img/nft-auth/auth.png";
import Image from "next/legacy/image";
import { Notice } from "./notice";
import { useRouter } from "next/router";

export function Intro() {
  const { locale } = useRouter();

  return (
    <div>
      <Image src={authImg} width={288} height={140} objectFit="contain" />
      <div className=" font-DIN_Alternate font-bold text-[48px] mt-[32px]">
        {locale === "cn"
          ? "授权合作平台用户使用 NFT 图片"
          : `Authorized use of NFT images in cooperation platforms`}
      </div>
      <Notice />
    </div>
  );
}
